export default __webpack_public_path__ + "static/media/t201.66c57cc3.jpg";